import { apiSlice } from "app/api/apiSlice";

export const logApiSlice = apiSlice.injectEndpoints({

    endpoints: builder => ({

        // GET Company Log
        getCompanyLog: builder.query({
            query: ({ pageNumber = 0, pageSize = 15 }) => ({
                url: '/log',
                params: { pageNumber, pageSize },
            }),
            keepUnusedDataFor: 5,
        }),
        // GET Current User Log
        getCurrentUserLog: builder.query({
            query: ({ pageNumber = 0, pageSize = 15 }) => ({
                url: '/log/me',
                params: { pageNumber, pageSize },
            }),
            keepUnusedDataFor: 5,
        }),

        // GET Company Activity Stats
        getCompanyActivityStats: builder.query({
            query: (lastDaysNumber) => ({
                url:'/log/stats',
                params: {lastDaysNumber}
            }),
            keepUnusedDataFor: 5,
        }),

        // GET User Activity Stats
        getUserActivityStats: builder.query({
            query: ({userGUID, lastDaysNumber}) => {
               return {
                    url: '/log/stats/user',
                    params : {
                        userGUID: userGUID,
                        lastDaysNumber: lastDaysNumber
                    }
               } 
            },
            keepUnusedDataFor: 5,
        }),
    })
})

export const {
    useGetCompanyLogQuery,
    useGetCurrentUserLogQuery,
    useGetCompanyActivityStatsQuery,
    useGetUserActivityStatsQuery
} = logApiSlice